import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack'
import { ReactNode } from 'react'
import { snackbarIconVariants } from './theme2/snackbar'

export const SnackbarProvider = ({ children }: { children: ReactNode }) => {
  return (
    <NotistackSnackbarProvider
      maxSnack={3}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      iconVariant={snackbarIconVariants}
    >
      {children}
    </NotistackSnackbarProvider>
  )
}
